export enum QuantuvisBusinessFeature {
  INTERNAL_BIDS = 'INTERNAL_BIDS',
}
